import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import PageTransition from '@/components/PageTransition';
import NewsletterSection from '@/app/components/NewsletterSection';
import ReviewsPageContent from '@/app/reviews/components/ReviewsPageContent';

export default function ReviewsPage() {
    return (
        <main className="min-h-screen bg-background">
            <Header />
            <PageTransition>
                <ReviewsPageContent />
                <NewsletterSection />
                <Footer />
            </PageTransition>
        </main>
    );
}
